import { makeStyles, Box, Container, Typography, useTheme, IconButton, Hidden } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import clsx from 'clsx';
import Qrcode from 'qrcode.react';
import React, { useEffect, useMemo, useState } from 'react';
import { useBranch } from '@zennya/web-component-library/src/components/BranchIO/BranchProvider'

const ASSETSIZE = 15
const useStyles = makeStyles((theme) => {
  return {
    fixed: {
      position: "fixed",
      bottom: 0,
      right: 10,
      zIndex: 9999
    },
    root: {
      background: "linear-gradient(90.55deg, #74BACD 0.47%, #7F8AAC 94.24%)",
      minHeight: 125,
      width: 170,
      aspectRatio:1,
      borderRadius: theme.shape.borderRadius,
      display: 'flex',
      padding: theme.spacing(1),
      paddingBottom: theme.spacing(3),
      alignItems: "center",
      justifyContent: "center",
      alignContent: "center",
      alignSelf: "center",
    },
    logo: {
      width: theme.spacing(ASSETSIZE),

    },
    content: {
      position: 'relative',
      display: "flex",
      flexDirection: "column",
      alignItems: 'center',

    },
    title: {
      color: "#fff",
      fontFamily: "HelvNeue",
      textAlign: "center",
    },
    close: {
      position: "absolute",
      top: 0,
      left: 0,
      color: "#fff",
    }
  }
})
const SquarePopUp = ({ fixed = false }) => {
  const classes = useStyles({ fixed })
  const theme = useTheme()
  const [closed, setClosed] = useState(false);

  const { deepLink, generateDeeplink } = useBranch({
    apiKey: process.env.REACT_APP_BRANCH_API_KEY,
  });

  useEffect(() => {
    generateDeeplink({ campaign: 'qrcode desktop web', tags: ['desktop', 'customtag2'], data: { 
      someData: 'some data',
      moreData: 'more data',

     } })
  }, [generateDeeplink]);

  return closed ? <></> : (
    <Hidden xsDown>
      <Box className={clsx(fixed ? classes.fixed : '', classes.root)}>
        <Box className={classes.content}>
          <Typography variant="body2" className={classes.title}>Scan to download the app</Typography>
          
          <Qrcode
            className={classes.logo}
            value={deepLink??""}
            renderAs="png"
            includeMargin
            size={theme.spacing(ASSETSIZE)}
          />
        </Box>
      </Box>
    </Hidden>
  )
}

export { SquarePopUp }